import React, { Component, createRef } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setAcessToken, setAcessTokenUser } from '../../redux/actions'
import { PowerBIEmbed } from 'powerbi-client-react'
import { models } from 'powerbi-client'
import { toast } from 'react-toastify'
import PowerbiService from '../../service/PowerbiService'
import './powerbiStyles.css'
import { Utils } from '../../utilities'
import FullscreenIcon from '@mui/icons-material/Fullscreen'

class PowerBiApresentacao extends Component {
  constructor(props) {
    super(props)

    this.state = {
      accessToken: '',
      reports: JSON.parse(localStorage.getItem('apresentacao')) || [],
      currentIndex: 0,
      acessouError: false,
      timerScreen: 20000, // 20 segundos
      timerScroll: 50, // 50 milissegundos
      isFullscreen: false,
    }

    window.reports = []

    // Criando a ref
    this.containerRef = createRef()
    this.ativarFullscreen = this.ativarFullscreen.bind(this)
    this.handleFullscreenChange = this.handleFullscreenChange.bind(this)
  }

  componentDidMount() {
    let newUser = JSON.parse(sessionStorage.getItem('auth'))
    let apresentacao = JSON.parse(localStorage.getItem('apresentacao')) || []
    let timerRelatorio =
      parseInt(JSON.parse(localStorage.getItem('timerRelatorio'))) || 60

    if (Utils.isNotObjectEmpty(newUser)) {
      this.setState({
        accessToken: newUser.accessToken,
        reports: apresentacao,
      })
    }

    if (this.props.powerbi) {
      let { accessToken } = this.props.powerbi
      this.setState({
        accessToken,
      })
    }
    // Alterna dashboards visíveis
    if (this.state.reports.length > 1) {
      this.interval = setInterval(() => {
        this.setState((prevState) => ({
          currentIndex: (prevState.currentIndex + 1) % prevState.reports.length,
        }))
      }, timerRelatorio * 1000) // troca a cada 20s

      // // Scroll automático dentro do PowerBI container visível
      // this.scrollInterval = setInterval(() => {
      //   const currentRef = this.containerRefs[this.state.currentIndex]
      //   if (currentRef?.current) {
      //     currentRef.current.scrollBy({ top: 1, behavior: 'smooth' })
      //     if (
      //       currentRef.current.scrollTop + currentRef.current.clientHeight >=
      //       currentRef.current.scrollHeight
      //     ) {
      //       currentRef.current.scrollTo({ top: 0, behavior: 'smooth' })
      //     }
      //   }
      // }, 50)
    }

    if (this.containerRef.current) {
      console.log('Elemento:', this.containerRef.current)
      this.containerRef.current.style.backgroundColor = 'rgb(245, 245, 245)'
    }
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
    clearInterval(this.scrollInterval)
    document.removeEventListener(
      'fullscreenchange',
      this.handleFullscreenChange,
    )
  }

  handleFullscreenChange() {
    const isFullscreen = !!document.fullscreenElement
    this.setState({ isFullscreen })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.mobilePowerbi !== this.props.mobilePowerbi) {
      window.location.reload()
    }

    if (prevProps.currentIndex !== this.state.currentIndex) {
      if (
        window.reports.length > 0 &&
        window.reports[this.state.currentIndex]
      ) {
        // setTimeout(() => {
        //   window.reports[this.state.currentIndex].fullscreen()
        // }, 2000)
        // setTimeout(() => {
        //   window.reports[this.state.currentIndex].exitFullscreen()
        // }, 4000)
      }
    }

    if (prevState.acessouError !== this.state.acessouError) {
      if (this.state.acessouError) {
        PowerbiService.getToken('/usuario/token')
          .then((data) => {
            window.setAcessToken(data.accessToken)
            window.setAcessTokenUser(data.accessToken)
            window.location.reload()
            this.setState({ acessouError: false })
          })
          .catch(() => {
            toast.error('Falha na conexão com o servidor', {
              theme: 'colored',
            })
          })
      }
    }
  }

  ativarFullscreen = () => {
    if (this.containerRef.current.requestFullscreen) {
      this.containerRef.current.requestFullscreen()
    } else if (this.containerRef.current.webkitRequestFullscreen) {
      this.containerRef.current.webkitRequestFullscreen()
    } else if (this.containerRef.current.mozRequestFullScreen) {
      this.containerRef.current.mozRequestFullScreen()
    } else if (this.containerRef.current.msRequestFullscreen) {
      this.containerRef.current.msRequestFullscreen()
    }
  }

  render() {
    const { reports, currentIndex } = this.state
    let newUser = JSON.parse(sessionStorage.getItem('auth'))
    let accessToken = newUser ? newUser.accessToken : ''

    window.setAcessToken = this.props.setAcessToken
    window.setAcessTokenUser = this.props.setAcessTokenUser

    return (
      <Grid
        justifyContent="center"
        alignItems="center"
        minHeight={'100%'}
        padding={2}
        paddingTop={4}
        ref={this.containerRef}
      >
        {!this.state.isFullscreen && (
          <Button
            startIcon={<FullscreenIcon />}
            variant="contained"
            onClick={this.ativarFullscreen}
          >
            Tela Cheia
          </Button>
        )}
        {reports.length === 0 && (
          <Grid
            minHeight={'70vh'}
            item
            xs={12}
            md={12}
            padding={2}
            marginLeft={2}
            justifyContent="center"
            alignItems="center"
            display="flex"
          >
            <Typography
              component="span"
              sx={{
                fontSize: '20px !important',
                fontWeight: 'bolder',
                marginBottom: 1,
              }}
              variant="h6"
              color={'#d32f2f'}
            >
              Nenhum relatório encontrado. Por favor, adicione relatórios em
              Config Apresentação.
            </Typography>
          </Grid>
        )}
        {reports.map((report, index) => {
          const embedUrl = `https://app.powerbi.com/reportEmbed?reportId=${report.powerBiReportId}&groupId=${report.powerBiGroupId}?rs:Embed=True&filterPaneEnabled=False`

          return (
            <Grid
              key={report.reportId}
              xs={12}
              marginTop={this.state.isFullscreen ? 5 : 2}
              item
              className="shadow"
              style={{
                display: index === currentIndex ? 'block' : 'none',
              }}
            >
              <PowerBIEmbed
                embedConfig={{
                  type: 'report',
                  id: report.powerBiReportId,
                  embedUrl: embedUrl,
                  accessToken: accessToken,
                  tokenType: models.TokenType.Aad,
                  settings: {
                    panes: {
                      pageNavigation: { visible: false },
                      filters: { expanded: false, visible: false },
                    },
                    layoutType: this.props.mobilePowerbi
                      ? models.LayoutType.MobilePortrait
                      : models.LayoutType.Master,
                  },
                }}
                eventHandlers={
                  new Map([
                    ['loaded', () => console.log(`Loaded: ${report.nome}`)],
                    ['rendered', () => console.log(`Rendered: ${report.nome}`)],
                    [
                      'error',
                      async (event) => {
                        if (
                          event.detail.errorCode === '403' ||
                          event.detail.message === 'TokenExpired'
                        ) {
                          PowerbiService.getToken('/usuario/token')
                            .then((data) => {
                              window.setAcessToken(data.accessToken)
                              window.setAcessTokenUser(data.accessToken)
                              window.location.reload()
                            })
                            .catch(() => {
                              toast.error('Falha na conexão com o servidor', {
                                theme: 'colored',
                              })
                            })
                        }
                      },
                    ],
                  ])
                }
                cssClassName={'powerbi-container'}
                getEmbeddedComponent={(embeddedReport) => {
                  // opcional: salvar referência

                  window.reports[index] = embeddedReport

                  // if (index === 0) {
                  //   window.report = embeddedReport
                  // }
                }}
              />
            </Grid>
          )
        })}
      </Grid>
    )
  }
}

const mapStateToProps = (store) => ({
  powerbi: store.powerbiReducer.powerbi,
  empresa: store.empresaReducer,
  mobilePowerbi: store.powerbiReducer.mobile,
})
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setAcessToken, setAcessTokenUser }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PowerBiApresentacao)
